module.exports = __webpack_public_path__ + "static/media/stockhausen_haut_17.40a298fc.jpg";